export type WithdrawalRouteProps = {
  goalId: string;
};

export enum WithdrawalReasonCode {
  GoalNotFound = "GOAL_NOT_FOUND",
  UserNotActive = "USER_NOT_ACTIVE",
  AccountNotFound = "ACCOUNT_NOT_FOUND",
  AccountNotActive = "ACCOUNT_NOT_ACTIVE",
  CompletedWithdrawalToday = "COMPLETED_WITHDRAWAL_TODAY",
  ProcessingWithdrawalExists = "PROCESSING_WITHDRAWAL_EXISTS",
}

export type WithdrawalStatusBannerProps = {
  reasonCode: WithdrawalReasonCode | string;
};
